import styled from "styled-components";

const StyledLocationWarningCopy = styled.div`
  margin-top: .5rem;
  margin-left: 10px;
  color: ${({ theme }) => theme.colors.error};
`;

export default StyledLocationWarningCopy;